/**
 * The take-off as the screen needs it. Colours come from the server (`uto_core.colours`),
 * so the legend, the overlay and the PDF always agree.
 */
import type { TakeoffConfiguration } from "@/api/client";

/** Unit id -> what the overlay needs to draw it. */
export function paintFor(
  configurations: readonly TakeoffConfiguration[],
): Map<string, { colour: string; mark: string; named: boolean }> {
  return new Map(
    configurations.map((c) => [c.unit_id, { colour: c.colour, mark: c.mark, named: c.named }]),
  );
}

/** `4'-0" x 9'-3"` from feet, for a panel's tooltip. */
export function feetInches(feet: number | null): string {
  if (feet === null || !Number.isFinite(feet)) {
    return "";
  }
  const inches = Math.round(feet * 12);
  return `${Math.floor(inches / 12)}'-${inches % 12}"`;
}
